import Spacer from '@/components/atoms/spacer'
import Container from '@/components/templates/container'

const Description = ({ description }) => {
  const base =
    'w-full max-w-[1064px] mx-auto text-bodyMobile md:text-body2Desktop text-umber text-center font-chivoMono my-mediumMobile lg:my-mediumDesktop'

  return (
    <Container outerClassName="mt-mediumMobile lg:mt-mediumDesktop">
      <Spacer />
      <p className={base}>{description}</p>
      <Spacer />
    </Container>
  )
}

export default Description
